import React, { VFC } from 'react';
import { Box, Loader } from 'wix-style-react';

export const LoadingState: VFC<{ dataHook: string }> = ({ dataHook }) => (
  <Box dataHook={dataHook}>
    <Loader size="large" />
  </Box>
);
